define((require) => {
    "use strict";

    var EditorEvents     = require("shared/services/EditorEvents"),
        EmailUtil        = require("util/EmailUtil"),
        ErrorHandler     = require("shared/services/error/ErrorHandler"),
        ImprovedView     = require("editor/zbone/ImprovedView"),
        LoggedIn         = require("shared/security/LoggedIn"),
        Permissions      = require("shared/security/Permissions"),
        RestApi          = require("shared/services/RestApi"),
        SequentialButton = require("util/SequentialButton"),
        {isBlank}        = require("shared/util/StringUtils"),
        SyncManager      = require("shared/services/sync/SyncManager"),
        template         = require("ui/settings/manageAccount/AddUserView.tpl"),
        ValidateBehavior = require("ui/behaviors/ValidateBehavior");

    /**
     * View for adding/creating a new Creator user.
     *
     * @class AddUserView
     * @constructor
     * @author Antonio Lagrotteria
     */
    return ImprovedView.extend({

        template: template,

        className: "add-user-view",

        title: "Add User",

        _addUser: null,

        ui: {
            name:  ".name",
            email: ".email",
            role:  ".roles",
            ok:    ".ok"
        },

        bindings: {
            ".name":  "name",
            ".email": "username"
        },

        events: {
            "click .ok": function() {
                this.options.okHandler(this._addUser);
            },
            "click .cancel": function() {
                this.options.cancelHandler();
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                buttonSubmit: ".ok",
                inputValidation: {
                    ".name": {
                        validator: function(name) {
                            return !isBlank(name);
                        },
                        errorText: "Name required"
                    },
                    ".email": {
                        validator: function(email) {
                            if (isBlank(email)) {
                                return false;
                            }

                            // Must be valid and must not be in use for the company...
                            var valid = EmailUtil.validateEmail(email);
                            return valid && this.options.emails.filter((e) => {
                                return email === e;
                            }).length === 0;
                        },
                        errorText: function(email) {
                            if (email) {
                                // If the email is here and it is a valid email, it means that the email is already in use.
                                return EmailUtil.validateEmail(email) ? "Email already in use" : "Not a valid email";
                            }

                            return "Email required";
                        }
                    },
                    ".roles": {
                        validator: function(role) {
                            return !isBlank(role);
                        },
                        errorText: "Role required"
                    }
                }
            }
        },

        /**
         * @private
         * Creates a new user based on validated form data.
         *
         * @return {Promise|*} A promise that will resolve to the created user, or <tt>SequentialButton.REJECT</tt>
         *                     if the form data is invalid; never null.
         */
        _createUser: function() {
            // Make sure the form is valid...
            if (!this.inputValidation()) {
                return SequentialButton.REJECT;
            }
            var name  = this.ui.name.val(),
                email = this.ui.email.val(),
                role  = this.ui.role.val();

            // We post a plain JSON object rather than using the more clean Backbone way for sending requests.
            // The reason is because privileges in the User model are computed, but do not get serialized by
            // the backend...
            return SyncManager.sync({
                method: "create-user",
                role:   Permissions.Roles.MANAGER,
                fn: { // http
                    type:        "POST",
                    url:          RestApi.API_URL + "/" + RestApi.Collections.USERS + "/create",
                    contentType: "application/json; charset=utf-8",
                    dataType:    "json",
                    data:         JSON.stringify({
                        companyId: LoggedIn.companyId(),
                        name:      name,
                        username:  email,
                        role:      role
                    })
                },

                resultHandler: function(user) {
                    var eventProperties = {
                        name: name,
                        username: email,
                        role: role,
                        userCreationType: "creator",
                        triggerOrigin: "AddUserModalOkButton"
                    };

                    EditorEvents.trigger(EditorEvents.constants.CREATE_USER, eventProperties);

                    return user;
                },
                errorHandler: function(error) {
                    return this._handleError(name, email, error);
                }.bind(this)

            }, {toString: function() { return email; }}).promise();
        },

        // Displays nice error in case email is in use (most common use case for 400 errors for users)...
        _handleError: function(name, email, error) {
            if (error.status === 400) { // bad request, i.e. user exist
                error.message = "&quot;" + email + "&quot; is already in use.";
            }

            // Resolve error message placeholders...
            ErrorHandler.inject(error, {
                method:   "creation",
                name:     "&quot;" + name + "&quot;",
                typeName: "User"
            });

            return "alert";
        },

        onRender: function() {
            this._addUser = SequentialButton.add(this.ui.ok, this._createUser.bind(this), true, true);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/manageAccount/AddUserView.js